var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99967 11.3333C2.69967 11.3333 0.833008 13.1916 0.833008 15.4999C0.833008 17.8083 2.69967 19.6666 4.99967 19.6666C7.29967 19.6666 9.16634 17.7999 9.16634 15.4999C9.16634 13.1999 7.30801 11.3333 4.99967 11.3333ZM3.29967 13.7999H4.99967C5.31634 13.7999 5.56634 14.0583 5.56634 14.3666C5.56634 14.6749 5.30801 14.9333 4.99967 14.9333H3.29967C2.983 14.9333 2.73301 14.6749 2.73301 14.3666C2.73301 14.0583 2.983 13.7999 3.29967 13.7999ZM6.69968 17.1999H3.29135C2.97468 17.1999 2.72467 16.9416 2.72467 16.6333C2.72467 16.3249 2.98302 16.0666 3.29135 16.0666H6.69968C7.01635 16.0666 7.26634 16.3249 7.26634 16.6333C7.26634 16.9416 7.01635 17.1999 6.69968 17.1999Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.167 3H5.83366C3.33366 3 1.66699 4.25 1.66699 7.16667V9.78333C1.66699 10.3917 2.292 10.775 2.85034 10.5333C3.767 10.1333 4.80865 9.98333 5.90031 10.1583C8.08365 10.5167 9.86699 12.2417 10.3087 14.4083C10.4337 15.0417 10.4503 15.6583 10.367 16.25C10.3003 16.7417 10.7003 17.175 11.192 17.175H14.167C16.667 17.175 18.3337 15.925 18.3337 13.0083V7.175C18.3337 4.25 16.667 3 14.167 3Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 10.3917C9.29998 10.3917 8.59165 10.1751 8.04998 9.73339L5.44164 7.65006C5.17498 7.43339 5.12498 7.04172 5.34165 6.77506C5.55831 6.50839 5.94997 6.45839 6.21664 6.67506L8.82497 8.75839C9.45831 9.26673 10.5333 9.26673 11.1666 8.75839L13.775 6.67506C14.0416 6.45839 14.4416 6.50006 14.65 6.77506C14.8666 7.04172 14.825 7.44172 14.55 7.65006L11.9416 9.73339C11.4083 10.1751 10.7 10.3917 9.99998 10.3917Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.783b0dea7b1c9052bf543e15548c2369.svg";
export { ForwardRef as ReactComponent };